import './print.sass';

import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Translate } from 'react-redux-i18n';

import trackDataTablePrint from 'actions/particular/trackDataTablePrint';

class Print extends React.Component {
  handleClick(event) {
    this.props.trackDataTablePrint({
      trackId: this.props.trackId,
      startFrame: this.props.startFrame,
      endFrame: this.props.endFrame,
      params: this.props.params || [],
    });
  }

  render() {
    let modifyer = '';
    if (this.props.startFrame === this.props.endFrame) {
      modifyer = 'is-disabled';
    }

    return (
      <ul className={ 'chart-print nav navbar-nav navbar-right ' + modifyer }>
        <li><a href='#' onClick={ this.handleClick.bind(this) }>
          <span
            className='glyphicon glyphicon-print'
            aria-hidden='true'>
          </span>
        </a></li>
      </ul>
    );
  }
}

function mapStateToProps(state) {
  return {
    startFrame: state.track.selectedStartFrame,
    endFrame: state.track.selectedEndFrame,
    params: state.trackTemplate.params
  };
}

function mapDispatchToProps(dispatch) {
  return {
    trackDataTablePrint: bindActionCreators(trackDataTablePrint, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Print);
